import { EfectivizarTransferenciaInternasMS } from './../../../open-api/model/efectivizarTransferenciaInternasMS';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-invoice',
  templateUrl: './transfer-invoice.component.html',
  styleUrls: ['./transfer-invoice.component.scss']
})
export class TransferInvoiceComponent implements OnInit {

  @Input() comprobante?: EfectivizarTransferenciaInternasMS;
  fecha = new Date().toLocaleDateString();
  constructor() { }

  ngOnInit(): void {
  }

}
